import { c as _c } from "react/compiler-runtime";
import { LinkExternal01Icon } from '@systemeio/icons';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerTagEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { FormSelect } from 'shared/components';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface TriggerTagItemProps extends EditTriggerItemInterface<TriggerTagEditInterface> {}
const TriggerTagItem = t0 => {
  const $ = _c(16);
  const {
    triggers,
    trigger,
    idx,
    errors,
    setRules,
    onDelete,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors.automationTriggers || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.id || $[9] !== trigger.tag || $[10] !== triggers) {
    t2 = t3 => {
      const {
        renderTriggerLabel,
        data,
        onOpen
      } = t3;
      return <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.tag)} required={true} label={renderTriggerLabel({
        label: t("dashboard.tag.title"),
        additionalLabel: trigger.tag.id ? <LinkWithoutPrefetch href={`/contacts?filter=%5B%7B"searchValue"%3A"${trigger.tag.id}"%2C"compareOperation"%3A"IN_LIST"%2C"searchField"%3A"tag"%7D%5D`} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><LinkExternal01Icon className="text-icon-tertiary transition-base group-focus-visible:text-icon-accent hover:text-icon-link-hover" /></LinkWithoutPrefetch> : undefined
      })} placeholder={t("dashboard.automation_rule.choose_tag")} value={trigger.tag.id} staticData={getDataFromObj(trigger.tag)} data={data.tagData} onChange={data_0 => setRules(prev => ({
        ...prev,
        triggers: triggers.map((el, i) => {
          if (idx === i) {
            return {
              ...el,
              tag: {
                id: data_0
              }
            };
          } else {
            return el;
          }
        })
      }))} error={errors.automationTriggers[trigger.id]?.tag?.join("")} />;
    };
    $[3] = errors.automationTriggers;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.id;
    $[9] = trigger.tag;
    $[10] = triggers;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[12] = t1;
    $[13] = t2;
    $[14] = trigger;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default TriggerTagItem;